import React from 'react';
import { Form, Input } from 'antd';
import { fieldNames, maxDescLength } from './constants';

const { Item: FormItem } = Form;
const { TextArea } = Input;

const DescriptionField = ({ form, initialValue, disabled = false }) => {
  const { getFieldDecorator, getFieldValue } = form;

  return (
    <FormItem
      label="Описание документа"
      colon={false}
      extra={`${
        (getFieldValue(fieldNames.description) ?? initialValue)?.length || 0
      }/${maxDescLength}`}
    >
      {getFieldDecorator(fieldNames.description, {
        initialValue: initialValue ?? '',
        rules: [
          {
            max: maxDescLength,
            message: 'Описание должно быть не больше 300 символов',
          },
        ],
      })(
        <TextArea
          autoSize={{ minRows: 2, maxRows: 5 }}
          disabled={disabled}
        />
      )}
    </FormItem>
  );
};

export default DescriptionField;
